import { gql } from '@apollo/client';

export const LOGOUT_OFFICER = gql`
mutation{
    signout
  }
`;
